const estadoPillStyle = {
  estadoPill: {
    fontSize: "0.75em",
    padding: "3px 12px",
    borderRadius: "10px",
    fontWeight: 600,
    whiteSpace: "nowrap",
    display: "inline-block",
    lineHeight: "1.6"
  },
  estadoPillConcluido: {
    backgroundColor: "#edf7ed",
    color: "#2e7d32"
  },
  estadoPillPendente: {
    backgroundColor: "#ede7f6",
    color: "#5e35b1"
  },
  estadoPillEmProgresso: {
    backgroundColor: "#fff8e1",
    color: "#b28700"
  },
  estadoPillInscrito: {
    backgroundColor: "#e3f2fd",
    color: "#1565c0"
  },
  estadoPillNaoAprovado: {
    backgroundColor: "#fdecea",
    color: "#c62828"
  },
  estadoPillNaoInscrito: {
    backgroundColor: "#f5f5f5",
    color: "#777"
  },
  estadoPillNaoApto: {
    backgroundColor: "#fdecea",
    color: "#c62828"
  }
};

export default estadoPillStyle;
